import React, { useState, useRef, useContext } from "react";
import SimpleHeader from "../../../../../components/Headers/SimpleHeader";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import { Card, CardBody, CardHeader, Button } from "reactstrap";
import EmpresaContext from "../../../../../contexts/Empresa";
import Funis from "../ConfiguracoesVendas/Funis";

const ConfiguracoesFunis: React.FC<any> = ({ history, ...props }) => {
  const notificationAlert = useRef<any>();
  const { empresaSelecionada } = useContext<any>(EmpresaContext);
  const [headerExtra, setHeaderExtra] = useState<any>(null);
  const [onNovo, setOnNovo] = useState<any>(null);

  const notify = (type: any, msg: string) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text" style={{ zIndex: 100 }}>
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 3,
    };
    if (notificationAlert.current)
      notificationAlert.current.notificationAlert(options);
  };

  return (
    <>
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Configurações de Funis/Pipelines" parentName="Minha empresa" />
      <div className="w-100">
        <Card>
          <CardHeader className="d-flex justify-content-between align-items-center">
            <h1 className="mb-0">Configurações de Funis/Pipelines</h1>
            <div className="d-flex align-items-center">
              {headerExtra}
              {onNovo && (
                <Button
                  color="primary"
                  type="button"
                  className="btn-icon btn-3 ml-2"
                  size="sm"
                  onClick={onNovo}
                >
                  <span className="btn-inner--icon">
                    <i className="ni ni-fat-add"></i>
                  </span>
                  <span className="btn-inner--text">Novo Funil/Pipeline</span>
                </Button>
              )}
            </div>
          </CardHeader>
          <CardBody outline body>
            {empresaSelecionada?.id && (
              <Funis
                {...props}
                history={history}
                notify={notify}
                empresa={empresaSelecionada}
                isActive={true}
                setHeaderExtra={setHeaderExtra}
                setOnNovo={setOnNovo}
                tipoFiltro="all"
              />
            )}
          </CardBody>
        </Card>
      </div>
    </>
  );
};

export default ConfiguracoesFunis;
